import { useEffect, useState } from 'react';

import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import { scrollToTop } from 'lib/utils';

import Body from './Body';
import Heading from './Heading';
import Sidebar from './Sidebar';
import StepperProvider from './Stepper/StepperProvider';

const GA_EVENT_CATEGORY = 'suggest_offer';
const SIDEBAR_STEPS = [
  'Cole o link da oferta',
  'Adicione o título da oferta',
  'Adicione o preço da oferta',
];

const SuggestNewOfferPage = () => {
  const { isMd } = useMediaQuery();
  const [suggestedOfferId, setSuggestedOfferId] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    sendEvent({
      action: 'load_page',
      category: GA_EVENT_CATEGORY,
    });
  }, []);

  const onSubmitSuccess = ({ offerId }) => {
    sendEvent({
      action: 'submit_success',
      category: GA_EVENT_CATEGORY,
    });

    setSuggestedOfferId(offerId);
    scrollToTop();
    setShowSuccessMessage(true);
  };

  const onSuggestAnotherOfferClick = () => {
    sendEvent({
      action: 'suggest_another_offer_click',
      category: GA_EVENT_CATEGORY,
    });
    setShowSuccessMessage(false);
  };

  return (
    <StepperProvider steps={SIDEBAR_STEPS}>
      <HeadWithNoIndexAndNoFollow />
      <Layout
        headingComponent={
          !(!isMd && showSuccessMessage) ? (
            <Heading className={showSuccessMessage && 'hidden md:block'} />
          ) : null
        }
        sidebarComponent={
          <Sidebar
            className="hidden xl:flex"
            gaEventCategory={GA_EVENT_CATEGORY}
            isShowingSuccessMessage={showSuccessMessage}
          />
        }
        maxWidthOnMobileDevices
      >
        <Body
          gaEventCategory={GA_EVENT_CATEGORY}
          showSuccessMessage={showSuccessMessage}
          suggestedOfferId={suggestedOfferId}
          onSubmitSuccess={onSubmitSuccess}
          onSuggestAnotherOfferClick={onSuggestAnotherOfferClick}
        />
      </Layout>
    </StepperProvider>
  );
};

export default SuggestNewOfferPage;
